import './translation-input.scss';
import { observer } from "mobx-react";
import IconTranslationIndicator from "../../components/icons/icon-translation-indicator/icon-translation-indicator";
import Icon from "../../components/icons/icon/icon";
import { Input } from "../../components/inputs/input/input";
import { IValidationGroup } from "../../hooks/validation-group/validation-group-hook";
import useTranslation from "../hooks/translation-hook";
import { Tooltip } from '../../components/tooltip/tooltip';
import FontBody2 from '../../components/fonts/font-body2/font-body2';
import { FONT_COLOR } from '../../components/fonts/font-props';

interface IProps {
    translationKey?: string;
    required?: boolean;
    validationGroup?: IValidationGroup;
}

const TranslationInput = observer(({ translationKey, required, validationGroup }: IProps) => {
    const { setTranslation, getTranslation, getHint, getDefaultTranslation, defaultLocale, selectedLocale} = useTranslation();

    const onChange = (val: any) => {
        if (translationKey && translationKey.trim() !== '') {
            setTranslation(translationKey as string, val);            
        }
        else {
            console.error('attempt to set translation without key');
        }
    }

    const placeHolder = (translationKey: string) => {
        return getHint(translationKey) ?? translationKey;
    }

    const indicator = () => <IconTranslationIndicator color={'var(--color-primary-1)'} />;

    return (
        <div className='translation-input'>
            <Input 
                value={getTranslation(translationKey as string)}
                placeholder={placeHolder(translationKey as string)}
                onChange={onChange}
                required={required}
                validationGroup={validationGroup}
            />

            <Tooltip content={<FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>Translatable field</FontBody2>}>
                <Icon Component={indicator} />
            </Tooltip>

            {selectedLocale !== defaultLocale && 
                <div className='suggestion'>
                    <strong>{defaultLocale}:</strong>
                    {getDefaultTranslation(translationKey as string)}
                </div>
            }
        </div>
    );
});

export default TranslationInput;
